
    <div id="show-coordinates">
      <div *ngIf="cartographic && showCoordinates">
      <fa-icon icon="map-marked-alt" style="color:orange" [matTooltip]="'MAP.CURSOR' | translate"></fa-icon>
        <small class="ml-2" [matTooltip]="'MAP.HEIGHT_CAPTION' | translate" matTooltipPosition="above">
          <fa-icon icon="arrow-from-bottom" [fixedWidth]="true"></fa-icon>
          <span *ngIf="measurementUnit === FEET">
              {{'MAP.HEIGHT_FEETS' | translate:{height: cartographic.height | round:3} }}
            </span>
          <span *ngIf="measurementUnit !== FEET">
              {{'MAP.HEIGHT_METERS' | translate:{height: cartographic.height | round:3} }}
            </span>
        </small>
        <small class="ml-1 mr-2" *ngIf="vertical_offset" >(<fa-icon [icon]="['fas','arrow-to-bottom']" [fixedWidth]="true" title="Height offset applied"></fa-icon>
          <span *ngIf="measurementUnit === FEET">
              {{'MAP.HEIGHT_FEETS' | translate:{height: vertical_offset | round:3} }}
            </span><span *ngIf="measurementUnit !== FEET">
              {{'MAP.HEIGHT_METERS' | translate:{height: vertical_offset | round:3} }}
            </span>)</small>

        <small [matTooltip]="'MAP.COORD_CAPTION' | translate" matTooltipPosition="above">
          <fa-icon icon="map-marker" [fixedWidth]="true"></fa-icon>
          <span *ngIf="projectedCoordinates">
            {{'MAP.COORD_PROJECTED' | translate: {
              lng: cartographic.longitude | round:3,
              lat: cartographic.latitude | round:3
              }
            }}
          </span>
          <span *ngIf="!projectedCoordinates">
            {{'MAP.COORD_NOT_PROJECTED' | translate: {
                lat: cartographic.latitude | round:7,
                lng: cartographic.longitude | round:7
              }
            }}
          </span>
        </small>
        <small class="ml-2"><fa-icon icon="clock" [fixedWidth]="true"></fa-icon> {{ mapService?.cameralocation?.timeLabel }} [{{ mapService?.cameralocation?.timeZone }}]</small>
        <fa-icon class="ml-2" *ngIf="slowDownZoom" icon="thumbtack" [fixedWidth]="true" title="Locked on 3D tileset (slowed zoom)"></fa-icon>
      </div>

      <div *ngIf="mapService?.cameralocation && showCameraCoordinates">
        <fa-icon icon="camera-movie" style="color:orange" [matTooltip]="'MAP.CAMERA' | translate"></fa-icon>
        <small class="ml-2" [matTooltip]="'MAP.HEIGHT_CAPTION' | translate" matTooltipPosition="above">
          <fa-icon icon="arrow-from-bottom" [fixedWidth]="true"></fa-icon>
          <span *ngIf="measurementUnit === FEET">
            {{'MAP.HEIGHT_FEETS' | translate:{height: mapService?.cameralocation?.height | round:3} }}
          </span>
          <span *ngIf="measurementUnit !== FEET">
              {{'MAP.HEIGHT_METERS' | translate:{height: mapService?.cameralocation?.height | round:3} }}
          </span>
        </small>
        <small class="ml-2" [matTooltip]="'MAP.COORD_CAPTION' | translate" matTooltipPosition="above">
          <fa-icon icon="map-marker" [fixedWidth]="true"></fa-icon>

          <span *ngIf="projectedCoordinates">
            {{'MAP.COORD_PROJECTED' | translate: {
              lng: cartographicCamera.longitude | round:3,
              lat: cartographicCamera.latitude | round:3
              }
            }}
          </span>
          <span *ngIf="!projectedCoordinates">
            {{'MAP.COORD_NOT_PROJECTED' | translate: {
                lat: mapService?.cameralocation?.latitude | round:7,
                lng: mapService?.cameralocation?.longitude | round:7
              }
            }}
          </span>


          <!-- <span *ngIf="projectedCoordinates">
            {{ 'MAP.LONGITUDE' | translate }} {{ mapService?.cameralocation?.longitude }} {{ 'MAP.LATITUDE' | translate }} {{ mapService?.cameralocation?.latitude }}
          </span>
          <span *ngIf="!projectedCoordinates">
            {{ 'MAP.LONGITUDE' | translate }} {{ mapService?.cameralocation?.longitude }} {{ 'MAP.LATITUDE' | translate }} {{ mapService?.cameralocation?.latitude }}
          </span> -->
        </small>
        <small *ngIf="heading" class="ml-2" [matTooltip]="'MAP.HEADING_CAPTION' | translate" matTooltipPosition="above">
          <fa-icon icon="compass" [fixedWidth]="true"></fa-icon>
          {{ 'MAP.HEADING_CAPTION' | translate }} {{ heading }}°
        </small>
      </div><!-- [{{hoverCounter}}] [{{ checked }}] -->
    </div>